document.addEventListener('DOMContentLoaded', function () {
	document.getElementById('navbar-toggler').addEventListener('click', function () {
		document.body.classList.toggle('navbar-active');
	});
});